import Reveal from "@/components/Reveal";

const STEPS = [
    { n: "01", title: "Understand", desc: "We understand your goals, requirements and the specific needs of your business." },
    { n: "02", title: "Plan", desc: "We create a clear plan based on your project timeline and expected outcomes." },
    { n: "03", title: "Create", desc: "We analyse data, build dashboards, design websites and create branding and digital content based on your needs." },
    { n: "04", title: "Deliver", desc: "We deliver your complete project with a focus on quality, clarity and your agreed requirements." },
    { n: "05", title: "Support", desc: "We help with questions and requested adjustments related to the delivered project." },
];

export default function Process() {
    return (
        <section id="process" className="py-20 lg:py-28 bg-cream-deep/45" data-testid="process-section">
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <Reveal className="text-center max-w-2xl mx-auto">
                    <div className="flex items-center justify-center gap-3 mb-4">
                        <span className="h-px w-10 bg-gold-deep" />
                        <span className="text-[11px] font-semibold tracking-[0.34em] text-burgundy">OUR PROCESS</span>
                        <span className="h-px w-10 bg-gold-deep" />
                    </div>
                    <h2 className="text-4xl sm:text-5xl text-charcoal">How We Work</h2>
                </Reveal>

                {/* Desktop — horizontal timeline */}
                <div className="hidden lg:grid relative grid-cols-5 gap-6 mt-20" data-testid="process-timeline-desktop">
                    <div className="absolute top-7 left-[10%] right-[10%] h-px bg-burgundy/25" aria-hidden="true" />
                    {STEPS.map((s, i) => (
                        <Reveal key={s.n} delay={i * 0.1} className="relative text-center px-2">
                            <div className="relative z-10 mx-auto w-14 h-14 rounded-full bg-cream border border-burgundy/30 flex items-center justify-center font-serif text-lg text-burgundy transition-colors duration-300 hover:bg-burgundy hover:text-cream">
                                {s.n}
                            </div>
                            <h3 className="mt-5 text-xl text-charcoal">{s.title}</h3>
                            <p className="mt-2 text-sm text-charcoal/65 leading-relaxed">{s.desc}</p>
                        </Reveal>
                    ))}
                </div>

                {/* Mobile — vertical timeline */}
                <div
                    className="lg:hidden relative mt-14 flex flex-col gap-10 before:absolute before:left-6 before:top-4 before:bottom-4 before:w-px before:bg-burgundy/20"
                    data-testid="process-timeline-mobile"
                >
                    {STEPS.map((s, i) => (
                        <Reveal key={s.n} delay={i * 0.06}>
                            <div className="flex gap-5 items-start">
                                <div className="relative z-10 w-12 h-12 shrink-0 rounded-full bg-cream border border-burgundy/30 flex items-center justify-center font-serif text-burgundy">
                                    {s.n}
                                </div>
                                <div>
                                    <h3 className="text-xl text-charcoal">{s.title}</h3>
                                    <p className="mt-1.5 text-sm text-charcoal/65 leading-relaxed">{s.desc}</p>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <Reveal className="mt-16 lg:mt-20 text-center">
                    <p className="font-serif italic text-lg sm:text-xl text-charcoal/70 max-w-2xl mx-auto">
                        We focus on understanding your needs and delivering thoughtful, professional solutions tailored to your business.
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
